import React, { useEffect, Component } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatIsNisa } from './components/WhatIsNisa';
import { Features } from './components/Features';
import { WhyNisaWorks } from './components/WhyNisaWorks';
import { VisionStory } from './components/VisionStory';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { AboutUs } from './pages/AboutUs';
import { PilotClosed } from './pages/PilotClosed';
import { ForSchools } from './pages/ForSchools';
import { Security } from './pages/Security';
import { SubProcessors } from './pages/SubProcessors';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ModalProvider } from './components/ModalContext';
import { BackgroundGraphics } from './components/BackgroundGraphics';
import { useAuthRedirect } from './hooks/useAuthRedirect';
// This component handles scrolling to anchors when the home page loads
const ScrollToAnchor = () => {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Remove the '#' character
      const id = hash.substring(1);
      // Give the DOM time to render before scrolling
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Scroll to top on route change when there's no hash
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};
// Component to handle auth redirect check
const AuthRedirectHandler = () => {
  useAuthRedirect();
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="nuhh6fb985sp">
      <ModalProvider data-id="element-1" data-mp="nv0xxsp64o55">
        <AuthRedirectHandler data-id="element-2" data-mp="nxn9e3f6jnsn" />
        <ScrollToAnchor data-id="element-3" data-mp="su45bjsmf6ga" />
        <div className="w-full min-h-screen bg-white text-gray-800 font-sans" data-id="element-4" data-mp="stkjhrzunxwz">
          <Routes data-id="element-5" data-mp="35ymodf6r9ya">
            <Route path="/terms" element={<>
                  <Header isStatic={true} data-id="element-7" data-mp="3ubrhql7qei4i" />
                  <Terms data-id="element-8" data-mp="3uf5ijp0qyj9u" />
                </>} data-id="element-6" data-mp="356tf9929ob6" />
            <Route path="/privacy" element={<>
                  <Header isStatic={true} data-id="element-10" data-mp="864atjm8yebm" />
                  <Privacy data-id="element-11" data-mp="3gle9siuub3f6" />
                </>} data-id="element-9" data-mp="d45tw4joadn3" />
            <Route path="/about" element={<>
                  <Header isStatic={true} data-id="element-13" data-mp="3bo4j6zvpslpr" />
                  <AboutUs data-id="element-14" data-mp="3qbpon0g2ax0u" />
                </>} data-id="element-12" data-mp="3gja7248ogagh" />
            <Route path="/pilot-program" element={<>
                  <Header isStatic={true} data-id="element-16" data-mp="2xuwv3i6ue8ct" />
                  <PilotClosed data-id="element-17" data-mp="2xtv7yfcjxveq" />
                </>} data-id="element-15" data-mp="3qd0oip6dzkmo" />
            <Route path="/schools" element={<>
                  <Header isStatic={true} data-id="element-19" data-mp="18d9c849dngr4" />
                  <ForSchools data-id="element-20" data-mp="18c6lbwc21eb7" />
                </>} data-id="element-18" data-mp="2swbtpffutims" />
            <Route path="/security" element={<>
                  <Header isStatic={true} data-id="element-22" data-mp="ygmtbl0m2zrq" />
                  <Security data-id="element-23" data-mp="ydqvdworkb3a" />
                </>} data-id="element-21" data-mp="1d5j9648wth2w" />
            <Route path="/sub-processors" element={<>
                  <Header isStatic={true} data-id="element-25" data-mp="1r526e206n80f" />
                  <SubProcessors data-id="element-26" data-mp="1w33p2ltp55bd" />
                </>} data-id="element-24" data-mp="13f7sri81hff4" />
            <Route path="/" element={<>
                  <Header data-id="element-28" data-mp="1i5nldi2sbpnb" />
                  <main className="relative" data-id="element-29" data-mp="1m4wdyjm39hha">
                    <BackgroundGraphics data-id="element-30" data-mp="1m3l88e931znj" />
                    <div className="relative z-10" data-id="element-31" data-mp="6ofgyws529j5">
                      <Hero data-id="element-32" data-mp="6mujozefwchl" />
                      <WhatIsNisa data-id="element-33" data-mp="6qs3ln8ud82j" />
                      <Features data-id="element-34" data-mp="aq9c6pjkelbx" />
                      <WhyNisaWorks data-id="element-35" data-mp="arkeekxd3l0x" />
                      <VisionStory data-id="element-36" data-mp="qx5hi1qbouc2" />
                      <CallToAction data-id="element-37" data-mp="qy73h18vn18k" />
                    </div>
                  </main>
                  <Footer data-id="element-38" data-mp="m65jsu9dq88i" />
                </>} data-id="element-27" data-mp="1w0zks2rvy4ak" />
          </Routes>
        </div>
      </ModalProvider>
    </BrowserRouter>;
}